import { makeStyles } from "@mui/styles";
import { UserCtx } from "../interfaces";
import { UserContext } from "../context/UserContext";
import { Role } from "../enums";
import { useContext } from "react";
import { termsContent } from "../TermsAndConditionsText";
const useStyles = makeStyles((theme) => ({
  textWrapper: {
    fontFamily: theme.typography.body1.fontFamily,
    color: theme.palette.text.primary,
    padding: "0 1.5em",
    textAlign: "left",
  },
  textTitle: {
    textAlign: "center",
  },
}));

enum TosType {
  HigherEd = "higherEd",
  K12 = "k12",
}
export const TermsAndConditionsText: React.FunctionComponent = () => {
  const userCtx = useContext(UserContext) as UserCtx;
  const classes = useStyles();
  let tosType = TosType.HigherEd;

  if (userCtx.dbUser.role !== Role.super) {
    const userSchool = userCtx.dbUser?.user_school?.[0]?.school?.name || "";
    tosType = userSchool.includes("ASUO") ? TosType.HigherEd : TosType.K12;
  }
  return tosType === TosType.HigherEd ? (
    <>
      <section className={classes.textWrapper}>
        <h2 className={classes.textTitle}>Digit Terms - HigherEd</h2>
        <p>{termsContent.higherEd.intro}</p>

        <h3>Overview of Digit.</h3>
        <p>{termsContent.shared.overViewOfDigit}</p>

        <h3>What Data Digit Collects.</h3>
        <p>{termsContent.higherEd.whatDigitCollects}</p>

        <h3>How We Use Your Digit Data.</h3>
        <p>{termsContent.higherEd.howWeUseYourDigitData}</p>

        <h3>Your Choices.</h3>
        <p>{termsContent.shared.yourChoices}</p>

        <h3>Children.</h3>
        <p>{termsContent.shared.children}</p>

        <h3>General Terms.</h3>
        <p>{termsContent.shared.generalTerms}</p>

        <h3>Accessibility.</h3>
        <p>{termsContent.higherEd.accessibility}</p>

        <h3>Limitation of Liability; Warranties; Disputes.</h3>
        <p>{termsContent.higherEd.limitation}</p>

        <h3>Permitted Use and Restrictions</h3>
        <p>{termsContent.shared.permittedUse}</p>

        <h3>Artificial Intelligence (AI) Use Agreement</h3>
        <p>{termsContent.higherEd.aiUse}</p>

        <h3>Disclaimer on Scientific and Medical Content</h3>
        <p>{termsContent.shared.disclaimer}</p>
      </section>
    </>
  ) : (
    <>
      <section className={classes.textWrapper}>
        <h2 className={classes.textTitle}>Digit Terms - K-12</h2>
        <p>{termsContent.k12.intro}</p>

        <h3>Overview of Digit.</h3>
        <p>{termsContent.shared.overViewOfDigit}</p>

        <h3>What Data Digit Collects.</h3>
        <p>{termsContent.k12.whatDigitCollects}</p>

        <h3>How We Use Your Digit Data.</h3>
        <p>{termsContent.k12.howWeUseYourDigitData}</p>

        <h3>Your Choices.</h3>
        <p>{termsContent.shared.yourChoices}</p>

        <h3>Children.</h3>
        <p>{termsContent.shared.children}</p>

        <h3>General Terms.</h3>
        <p>{termsContent.shared.generalTerms}</p>

        <h3>Accessibility.</h3>
        <p>{termsContent.k12.accessibility}</p>

        <h3>Limitation of Liability; Warranties; Disputes.</h3>
        <p>{termsContent.k12.limitation}</p>

        <h3>Permitted Use and Restrictions</h3>
        <p>{termsContent.shared.permittedUse}</p>

        <h3>Artificial Intelligence (AI) Use Agreement</h3>
        <p>{termsContent.k12.aiUse}</p>

        <h3>Disclaimer on Scientific and Medical Content</h3>
        <p>{termsContent.shared.disclaimer}</p>
      </section>
    </>
  );
};
